exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1hwLdCGlFN-_y5jPMUYTAS{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0)}html[dir] ._1hwLdCGlFN-_y5jPMUYTAS{padding:0;margin:-1px;border:0}", ""]);
// Exports
exports.locals = {
	"n-srOnly": "_1hwLdCGlFN-_y5jPMUYTAS"
};